module.exports = __webpack_public_path__ + "media/notification.2f1d885e.ogg";